import _extends from "@babel/runtime/helpers/esm/extends";

var _this = this,
    _jsxFileName = "/opt/build/repo/src/Switch.tsx";

import React from 'react';
import FormCheck from './FormCheck';
var Switch = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(FormCheck, _extends({}, props, {
    ref: ref,
    type: "switch",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 19
    }
  }));
});
Switch.displayName = 'Switch';
Switch.Input = FormCheck.Input;
Switch.Label = FormCheck.Label;
export default Switch;